/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TripleGripperIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Triple Gripper',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 8"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
    width="${width}"
    height="${height}"
  >
    <path
      d="M9.45 1.05H.55a.5.5 0 0 1 0-1h8.9a.5.5 0 0 1 0 1m.5 2.45a.5.5 0 0 0-.5-.5H.55a.5.5 0 0 0 0 1h8.9a.5.5 0 0 0 .5-.5m0 3a.5.5 0 0 0-.5-.5H.55a.5.5 0 0 0 0 1h8.9a.5.5 0 0 0 .5-.5"
    />
  </svg>`;
};
